import firebase from "firebase/app";
import "firebase/database";
import {
  firebaseConfig,
  firebaseConfig2,
  firebaseConfig3
} from "./firebaseConfig";

export const app1 = firebase.initializeApp(firebaseConfig, "db1");
export const app2 = firebase.initializeApp(firebaseConfig2, "db2");
export const app3 = firebase.initializeApp(firebaseConfig3, "db3");
export const initalizedFirebase = firebase;
